import dynamic from "next/dynamic";

export const DynamicSliderView = dynamic(() => import("./SliderView"), {
  suspense: true,
});
